import * as React from 'react';
import { League } from '../../../../sdk/model';
import {Box, Typography, Button, TextField} from '@mui/material';
import {positionOrder} from '../../../util/PositionOrder';
import RosterConfig from './RosterConfig';
import { leagueApi } from '../../../../adapters/APIExporter'

interface rosterSettingsProps {
  league: League,
  readOnly: boolean
}

function RosterSettings(props: rosterSettingsProps) {
  const [editMode, setEditMode] = React.useState(false);
  const [rosterSettings, setRosterSettings] = React.useState({...props.league.rosterSettings})
  const [tradeDeadline, setTradeDeadline] = React.useState(props.league.currentSeason?.tradeDeadlineWeek)
  
  function handleRosterChange(event) {
    const {name, value} = event.target;
    let newRosterSettings = {...rosterSettings};
    newRosterSettings[name] = Number(value);
    setRosterSettings(newRosterSettings);
  }
  
  function saveRosterSettings() {
    const newLeague = {...props.league};
    newLeague.rosterSettings = {...rosterSettings};
    newLeague.currentSeason = {...rosterSettings.currentSeason};
    newLeague.currentSeason.tradeDeadlineWeek = tradeDeadline;
    leagueApi.updateLeague(newLeague.id, newLeague).then(() => setEditMode(false));
  }
  
  if (editMode) {
    return <Box>
      <RosterConfig rosterSettings={rosterSettings} handleRosterChange={handleRosterChange} />
      <br/>
      <TextField name="tradeDeadline" label="Trade Deadline Week:" value={tradeDeadline} type="number" 
        InputProps={{inputProps: {min: 0, max: 18}}} onChange={event => setTradeDeadline(event.target.value)}/>
      <br/>
      <Button className='capsized-button' onClick={() => {
        setRosterSettings({...props.league.rosterSettings});
        setTradeDeadline(props.league.currentSeason?.tradeDeadlineWeek);
        setEditMode(false);
      }}>Cancel</Button>
      <Button className='capsized-button' onClick={saveRosterSettings}>Save</Button>
    </Box>
  }
  return <Box>
    {positionOrder.map(position => [position, rosterSettings![position]])
      .filter(positionInfo => positionInfo[1])
      .map(positionInfo => <Typography key={positionInfo[0]}>{positionInfo[0]} - {positionInfo[1]}</Typography>)}
    <Typography>Trade deadline: Week {tradeDeadline}</Typography>
    {props.readOnly || <Button className='capsized-button' onClick={() => setEditMode(true)}>Edit Roster Settings</Button>}
  </Box>
}

export default RosterSettings;
